const main_path = '@/pages/user'

const ExecutionRoutes = [
  {
    path: '/',
    name: 'ExecutionList',
    meta: { 
      auth: true, 
      // roles: ['admin', 'super_admin', 'execute'],
    },
    component: () => import(`@/pages/execution/ExecutionList.vue`)
  },
  {
    path: '/execution/create',
    name: 'CreateExecution',
    meta: {
      auth: true,
      roles: ['admin', 'super_admin'],
    },
    component: () => import('@/pages/execution/NewExecution.vue')
  },
  {
    path: '/execution/:id',
    name: 'ShowExecution',
    meta: {
      auth: true,
      roles: ['admin', 'super_admin', 'execute'],
    },
    component: () => import('@/pages/execution/ShowExecution.vue')
  }
]

export default ExecutionRoutes
